import { Outlet, useNavigate } from 'react-router-dom';
import AppHeader from '@/app/layouts/AppHeader';
import BottomNavigation from '@/app/layouts/BottomNavigation';
import { useSession } from '@/app/providers/session-provider';
import { getRoutePath, ROUTE_IDS } from '@/app/router/route-registry';
import { LinkedEntityCardProvider } from '../../shared/components/linked-entities/LinkedEntityCardHost';

export default function TenantShell() {
  const navigate = useNavigate();
  const { currentUser, isWorkspaceAccess, exitWorkspaceAccess } = useSession();
  const adminTenantsPath = getRoutePath(ROUTE_IDS.ADMIN_TENANTS) || '/admin/tenants';

  async function handleExitWorkspace() {
    await exitWorkspaceAccess();
    navigate(adminTenantsPath, { replace: true });
  }

  return (
    <LinkedEntityCardProvider>
    <div className="app-shell">
      <AppHeader />
      {isWorkspaceAccess ? (
        <div className="workspace-access-banner">
          <div className="workspace-access-banner__copy">
            <span className="workspace-access-banner__label">Workspace Access</span>
            <span className="workspace-access-banner__text">
              Stai operando come SUPER_ADMIN nel workspace {currentUser?.tenant?.name || currentUser?.tenantId}.
            </span>
          </div>
          <button
            type="button"
            className="workspace-access-banner__exit"
            onClick={handleExitWorkspace}
          >
            Esci dal workspace
          </button>
        </div>
      ) : null}
      <div className="app-body">
        <main className="app-main">
          <Outlet />
        </main>
      </div>
      <BottomNavigation />
    </div>
    </LinkedEntityCardProvider>
  );
}
